<template>
  <div class="layout-user">
    <div class="content-layout">
      <div class="wrap-header">
        <div class="header">
          <img src="@/assets/abi-vertical.png" alt="" class="img-logo" />

          <div class="dropdown">
            <button class="btn btn-logout" @click="logout"><b-icon icon="power" aria-hidden="true" class="icon"></b-icon></button>

            <!-- <div class="dropbtn">{{ userProfil }} <b-icon icon="chevron-down"></b-icon></div>
            <div class="dropdown-content">
              <div @click="logout">Logout</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="main-content">
        <router-view></router-view>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  components: {
    // RegisterPribadi,
  },
  data() {
    return {
      username: "",
    };
  },
  mounted() {
    Axios.get("/v2/user/profile").then((res) => {
      this.username = res.data.data.user.account_code;
    });
  },
  computed: {
    isLogin() {
      return this.$store.getters.isAuthenticated;
    },
    userProfil() {
      let user = localStorage.getItem("username");
      return user;
    },
    role() {
      let role = localStorage.getItem("role");
      // console.log(role)
      return role;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        let role = localStorage.getItem("role");
        if (role == 5) {
          this.$router.go("/login-admin");
        } else {
          this.$router.go("/home");
        }
      });
    },
  },
};
</script>

<style scoped>
.layout-user {
  background: rgba(197, 151, 51, 0.4);
  min-height: 100vh;
}

.wrap-header {
  padding: 10px 0;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: auto;
  height: 70px;
}

.img-logo {
  height: 50px;
}

.img-akun {
  width: 30px;
}

.btn-logout {
  background: transparent;
}

.btn-logout .icon {
  font-size: 28px;
}
.btn-logout:hover .icon {
  color: var(--scondary);
}

.btn-logout:focus {
  outline: none;
}

.btn-logout:hover {
  color: var(--scondary);
  transform: translateY(-1px);
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}

.footer {
  /* height: 75px; */
  color: var(--primary);
  padding: 20px;
  display: flex;
  justify-content: space-between;
  height: 62px;
  width: 80%;
  margin: 50px auto 0;
}

.footer span {
  font-size: 16px;
  flex: 2;
  font-weight: bold;
}

.footer .contact {
  display: flex;
  /* width: 30%; */
  justify-content: space-between;
}

.footer .contact div:first-child {
  margin-right: 51px;
}

.footer .contact img {
  width: 20px;
  margin-right: 11px;
}

.footer .contact span {
  font-size: 12px;
}

.dropbtn {
  /* background-color: #04aa6d; */
  /* color: white; */
  padding: 16px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content div {
  color: #707070;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.dropdown:hover .dropdown-content {
  display: block;
}

/* .dropdown:hover .dropbtn {
  background-color: #3e8e41;
} */

@media (max-width: 720px) {
  .header {
    width: 90%;
  }
}
</style>
